import { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import { LuUsersRound } from "react-icons/lu";
import { CiHeart } from "react-icons/ci";

import "./index.css";

const companies = [
  {
    name: "Google",
    logo: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773830661/download_5_qdcxax.png",
  },
  {
    name: "Microsoft",
    logo: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773830023/Adobe_Express_-_file_6_fsfjbp.png",
  },
  {
    name: "Amazon",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/80px-Amazon_logo.svg.png",
  },
  {
    name: "Meta",
    logo: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773830282/download_2_dffcjz.png",
  },
  {
    name: "Apple",
    logo: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773830367/download_3_wfqqp1.png",
  },
  {
    name: "Netflix",
    logo: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773830480/download_4_eelrbc.png",
  },
  //   {
  //     name: "Tesla",
  //     logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Tesla_T_symbol.svg/80px-Tesla_T_symbol.svg.png",
  //   },
  //   {
  //     name: "Spotify",
  //     logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Spotify_logo_without_text.svg/80px-Spotify_logo_without_text.svg.png",
  //   },
];

const MentorSupport = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="mentors-section">
      <div className="mentors-header" data-aos="fade-up">
        <div className="mentors-icons">
          <LuUsersRound /> <CiHeart className="heart-icon" />
        </div>
        <h2>
          Learn from Industry <br />
          <span>Experts & Mentors</span>
        </h2>
        <p>
          Get personalized guidance from experienced professionals working at
          top tech companies who are passionate about sharing their knowledge
        </p>
      </div>
      <div className="mentors-companies">
        {companies.map((company, idx) => (
          <div
            key={company.name}
            className="company-card"
            data-aos="zoom-in"
            data-aos-delay={idx * 100}
          >
            <img src={company.logo} alt={company.name} />
            {/* <p>{company.name}</p> */}
          </div>
        ))}
      </div>
    </section>
  );
};

export default MentorSupport;
